import { labelOf, ORDER_STATUSES, type OrderStatusKey } from '@c214/shared';
import { cn } from '../../lib/utils';

const DOT_COLOR: Record<OrderStatusKey, string> = {
  roasting: 'bg-warn',
  shipping: 'bg-accent',
  delivered: 'bg-muted',
  cancelled: 'bg-muted-2',
};

export function OrderStatusDot({ status }: { status: OrderStatusKey }) {
  return (
    <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.12em] text-muted">
      <span className={cn('h-[7px] w-[7px] rounded-full', DOT_COLOR[status])} />
      {labelOf(ORDER_STATUSES, status)}
    </span>
  );
}
